import React, { useState, useEffect } from 'react';
import { rootURL } from "../../constants";
import Cookies from 'js-cookie';

interface MicrosoftAuthProps {
  onTokenReceived?: (token: string) => void;
  onUserNameReceived?: (username: string) => void;
  disabled: boolean;
}

const MicrosoftAuth: React.FC<MicrosoftAuthProps> = ({ disabled = false }) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [userData, setUserData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  // Check for token in URL when component mounts
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const msToken = urlParams.get('ms_token');
    
    if (msToken) {
      console.log('Microsoft token found in URL');
      setAccessToken(msToken);

      // Set cookie with 7 days expiration
      Cookies.set('ms_access_token', msToken, { expires: 7 });
      Cookies.set('ms_access_token1', '111', { path: '/', expires: 3 }); // Cookie will expire in 3 days
      
      // Clean up URL parameters (optional)
      // window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <div style={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'flex-end' }}>
      <a 
        href={`${rootURL}/social-auth/login/azuread-oauth2`}
        style={{
          backgroundColor: '#2F2F2F',
          color: 'white',
          padding: '6px 12px',
          borderRadius: '4px',
          border: 'none',
          fontFamily: 'Segoe UI, Helvetica, Arial, sans-serif',
          fontSize: '13px',
          fontWeight: 'bold',
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
          width: '100%',
          maxWidth: '200px',
          minWidth: '0',
          height: 'auto',
          boxSizing: 'border-box',
          justifyContent: 'center',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 23 23" fill="white" style={{ 
          marginRight: '6px',
          flexShrink: 0,
        }}>
          <path d="M0 0h10.931v10.931H0V0z" fill="#f25022"/>
          <path d="M12.069 0H23v10.931H12.069V0z" fill="#7fba00"/>
          <path d="M0 12.069h10.931V23H0V12.069z" fill="#00a4ef"/>
          <path d="M12.069 12.069H23V23H12.069V12.069z" fill="#ffb900"/>
        </svg>
        <span style={{ 
          overflow: 'hidden', 
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          minWidth: 0,
          flex: 1,
          textAlign: 'center',
        }}>
          Login with Microsoft
        </span>
      </a>
    </div>
  );
};

export default MicrosoftAuth;